import type { Country } from '@/shared/model';

export type VisaTone = 'success' | 'brand';

export interface VisaLabel {
  text: string;
  tone: VisaTone;
}

const VISA_ONLINE: VisaLabel = { text: 'онлайн-виза', tone: 'brand' };
const VISA_REQUIRED: VisaLabel = { text: 'виза', tone: 'brand' };
const VISA_FREE: VisaLabel = { text: 'без визы', tone: 'success' };

export function getVisaLabel(country: Pick<Country, 'visaOnline' | 'visaRequired'>): VisaLabel {
  if (country.visaOnline) {
    return VISA_ONLINE;
  }
  if (country.visaRequired) {
    return VISA_REQUIRED;
  }
  return VISA_FREE;
}
